import { render, staticRenderFns } from "./Alibaba-buyer-info.vue?vue&type=template&id=1bd483b7&"
import script from "./Alibaba-buyer-info.vue?vue&type=script&lang=js&"
export * from "./Alibaba-buyer-info.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-buyer-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports